import { LDSAvatar, LDSHeading } from "@resmed/lumina-design-system";

export interface TypingIndicatorProps {
  /** Raw typing text from the server, e.g. "John is typing..." — already identifies the actual typer */
  text: string;
  avatarLabel?: string;
  avatarImage?: string;
}

const TypingIndicator = ({
  text,
  avatarLabel,
  avatarImage,
}: TypingIndicatorProps) => {
  return (
    <div className="lds-flex lds-items-center lds-gap-[10px]">
      <LDSAvatar
        size="small"
        shape="circle"
        image={avatarImage}
        label={avatarLabel}
        imageFallback="default"
      />
      <LDSHeading
        size="h5"
        className="lds-typography-xs-medium lds-text-textcolor-weak"
      >
        {text}
      </LDSHeading>
    </div>
  );
};

export default TypingIndicator;
